export default __webpack_public_path__ + "static/media/guesty_step6.41233832.png";